import { render } from "./customAccordion.vue?vue&type=template&id=2206c3a3"
import script from "./customAccordion.vue?vue&type=script&lang=js"
export * from "./customAccordion.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__